import request from "@/utils/oms-request";
import download from "@/utils/oms-download";

export const searchTaskList = (params: any) =>
  request({
    url: "/task",
    method: "get",
    params,
  });

export const viewTaskLog = (params: any) =>
  request({
    url: "/task-log",
    method: "get",
    params,
  });

export const downloadViewTaskLog = (taskId) =>
  download({
    responseType: "blob",
    url: `/task-log/${taskId}/download`,
    method: "get"
  });

export const deleteTask = (id: string) =>
  request({
    url: `/task/${id}`,
    method: "DELETE",
  });

export const downloadExl = (id: string) =>
  request({
    responseType: "blob",
    url: `/task/oss/${id}`,
    method: "GET",
  });

export const deleteOrderLibrary = (taskId: string) =>
  request({
    url: `/order-library/re-upload?taskId=${taskId}`,
    method: "DELETE",
  });
export const deleteQuoteLibrary = (taskId: string) =>
  request({
    url: `/quote-library/re-upload-to-delete?taskId=${taskId}`,
    method: "DELETE",
  });


